/**
 * Converts a string from various cases (camelCase, snake_case, kebab-case) to normal case
 * Example: 'camelCase' -> 'Camel Case', 'snake_case' -> 'Snake Case'
 */
const useNormalCase = () => {
    /**
     * Convert a string to normal case (spaces between words, first letter capitalized)
     * @param input The string to convert
     * @returns The normalized string
     */
    const toNormalCase = (input: string): string => {
        if (!input) return "";

        // Handle different cases: camelCase, snake_case, kebab-case, etc.
        let result = input
            // Insert space before capital letters in camelCase
            .replace(/([A-Z])/g, " $1")
            // Replace underscores and hyphens with spaces
            .replace(/[_-]/g, " ")
            // Remove extra spaces
            .replace(/\s+/g, " ")
            .trim();

        // Capitalize first letter
        return result.charAt(0).toUpperCase() + result.slice(1);
    };

    return {
        toNormalCase,
    };
};



export { useNormalCase };
